import { render, staticRenderFns } from "./AvdTecnica.vue?vue&type=template&id=e548be7e"
import script from "./AvdTecnica.vue?vue&type=script&lang=js"
export * from "./AvdTecnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports